export default [

     {
          path: '/milestone',
          name: 'Milestone',
          component: () => import("@/views/Page/Milestone/Milestone.vue"),
           meta: {
               title: 'Milestone',
          },
     }
];